import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '../../Modal';
import * as Ui from './styles.js';
import RichTextBox from '../../RichTextBox';
import { Loading } from '../../Loading';
import { MAX_CHARACTERS } from './const';


/**
 * Componente que exibe as anotacoes dos resultados
 * de um card
 */
const propTypes = {
  initialText: PropTypes.shape({
    ops: PropTypes.arrayOf(
      PropTypes.shape({
        insert: PropTypes.string,
        attributes: PropTypes.object,
      }),
    ),
  }),
  annotationsTools: PropTypes.arrayOf(PropTypes.string),
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  isLoading: PropTypes.bool,
  title: PropTypes.string,
  placeholder: PropTypes.string,
};
const defaultProps = {
  annotationsTools: ['bold', 'italic', 'underline', 'strike', 'listOrdered', 'listBullet'],
  isLoading: false,
  title: 'Anotações',
  placeholder: 'Faça suas anotações',
};

function CardAnnotations(props) {
  // state from props
  const { onSave, onCancel, annotationsTools, initialText, isLoading, title, placeholder } = props;
  const [annotationsCurrentState, setAnnotationsCurrentState] = useState();

  useEffect(() => {
    if (initialText) {
      setAnnotationsCurrentState(initialText);
    }
  }, [initialText]);

  function handleSave() {
    onSave && onSave(annotationsCurrentState);
  }

  function handleCancel() {
    onCancel && onCancel();
  }

  function onTextChange(newText) {
    setAnnotationsCurrentState(newText);
  }

  return (
    <Ui.Container className="CardAnnotations-container">
      <Modal
        isLoading={isLoading}
        isOpen
        title={title}
        okBtnTitle={'Salvar'}
        cancelBtnTitle={'Cancelar'}
        onOk={handleSave}
        okBtnClickable={!!annotationsCurrentState &&
          annotationsCurrentState.length <= MAX_CHARACTERS.LIMIT}
        onCancel={handleCancel}
        iconComponent={<Ui.AnnotationsIcon />}
      >
        {
          isLoading ? <Loading size={20} running />
            : (
              <div className="annotations-wrapper">
                <RichTextBox
                  initialText={initialText}
                  tools={annotationsTools}
                  onChange={onTextChange}
                  placeholder={placeholder}
                />
              </div>
            )
        }

      </Modal>
    </Ui.Container>
  );
}

CardAnnotations.propTypes = propTypes;
CardAnnotations.defaultProps = defaultProps;
export default CardAnnotations;
